import { GameFont } from "by/gamefactory/cityversetycoon/scenes/common/GameFont";
import { DropShadowFilter } from "pixi-filters";
import { Container, Text, TextStyle } from "pixi.js";

export class RenterAdditionalPageTextContainer extends Container {
    public constructor() {
        super();
        const becomeText = new Text(`BECOME`, new ContainerTextStyle());
        becomeText.style.fontSize = 90;
        becomeText.angle = -5;
        becomeText.skew.x = -0.08;
        this.addChild(becomeText);
        const anText = new Text(`AN`, new ContainerTextStyle());
        anText.style.fontSize = 64;
        anText.style.fill = ["#ffe50c", "#ffa41c"];
        anText.angle = -5;
        anText.skew.x = -0.08;
        anText.position.set(-7, 77);
        this.addChild(anText);
        const ownerText = new Text(`OWNER`, new ContainerTextStyle());
        ownerText.style.fontSize = 180;
        ownerText.style.fill = ["#ffe50c", "#ffa41c"];
        ownerText.angle = -5;
        ownerText.skew.x = -0.08;
        ownerText.position.set(45, 66);
        this.addChild(ownerText);
        const receiveText = new Text(`AND RECEIVE`, new ContainerTextStyle());
        receiveText.style.fontSize = 62;
        receiveText.angle = -5;
        receiveText.skew.x = -0.08;
        receiveText.position.set(55, 207);
        this.addChild(receiveText);
        const precentText = new Text(`100%`, new ContainerTextStyle());
        precentText.style.fontSize = 180;
        precentText.style.fill = ["#ffe50c", "#ffa41c"];
        precentText.angle = -5;
        precentText.skew.x = -0.08;
        precentText.position.set(-28, 267);
        this.addChild(precentText);
        const rewardsText = new Text(`OF YOUR REWARDS`, new ContainerTextStyle());
        rewardsText.style.fontSize = 81;
        rewardsText.style.fill = ["#94f60b", "#18cf17"];
        rewardsText.angle = -5;
        rewardsText.skew.x = -0.08;
        rewardsText.position.set(-13, 405);
        this.addChild(rewardsText);
        const additionalText = new Text(`WITHOUT HAVING TO SHARE\nTHEM WITH YOUR LANDLORD`, new ContainerTextStyle());
        additionalText.style.fontSize = 72;
        additionalText.style.fill = "#012762";
        additionalText.style.align = "center";
        additionalText.style.dropShadow = true;
        additionalText.style.dropShadowAngle = 0;
        additionalText.style.dropShadowBlur = 13;
        additionalText.style.dropShadowColor = "#ffffff";
        additionalText.style.dropShadowDistance = 0;
        additionalText.angle = -5;
        additionalText.skew.x = -0.08;
        additionalText.position.set(-82, 552);
        additionalText.filters = [new DropShadowFilter({ blur: 7, quality: 4, alpha: 0.7, color: 0x0085FF }),new DropShadowFilter({ blur: 4, quality: 4, alpha: 1, color: 0xffffff })];
        this.addChild(additionalText);
    }
}

class ContainerTextStyle extends TextStyle {
    public constructor() {
        super({
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 78,
            fill: 'ffffff'
        });
    }
}